// Entry point for the build script in your package.json
import "@hotwired/turbo-rails";
import "./channels/consumer";
import Alpine from "alpinejs";
import Sortable from "sortablejs";
import "flowbite/lib/esm/index.turbo";
import "chartkick/chart.js";
import registerEditor from "./components/editor";
import registerSectionEditor from "./components/section_editor";
import registerKanban from "./components/kanban";
import registerCelebration from "./components/celebration";
import registerGlobalSearch from "./components/global_search";
import registerChat from "./components/chat";
import registerDatepicker from "./components/datepicker";
import registerModal from "./components/modal";
import registerNotifications from "./components/notifications";
import registerDropzone from "./components/dropzone";
import registerCalendar from "./components/calendar";
import registerAvailabilityPicker from "./components/availability_picker";
import registerPageEditor from "./components/page_editor";
import registerAgentJob from "./components/agent_job";
import registerAgentPanel from "./components/agent_panel";
import registerStageSortable from "./components/stage_sortable";
import registerSidebar from "./components/sidebar";
import registerMentionLink from "./components/mention_link";
import registerMentionTextarea from "./components/mention_textarea";
import registerAnchorHighlight from "./components/anchor_highlight";
import registerTimelineMentionedMe from "./components/timeline_mentioned_me";
import registerMarkdownEditor from "./components/markdown_editor";
import registerAiTemplateGenerator from "./components/ai_template_generator";
import registerEmailCompose from "./components/email_compose";
import registerComposeHelpers from "./components/compose_helpers";
import registerAddressAutocomplete from "./components/address_autocomplete";
import registerBookingCalendar from "./components/booking_calendar";
import registerAvailabilityRules from "./components/availability_rules";
import registerTableCustomizer from "./components/table_customizer";
import registerBulkSelect from "./components/bulk_select";
import registerLineItemModal from "./components/line_item_modal";
import registerProductsModal from "./components/products_modal";
import registerSignaturePad from "./components/signature_pad";
import registerBundleViewer from "./components/bundle_viewer";
import registerOtpInput from "./components/otp_input";
import registerPhoneInput from "./components/phone_input";
import registerCounterSignModal from "./components/counter_sign_modal";
import registerContactPicker from "./components/contact_picker";
import registerCustomerPicker from "./components/customer_picker";
import registerMoveContactModal from "./components/move_contact_modal";
import registerOpportunityEditModal from "./components/opportunity_edit_modal";
import registerTenderSearch from "./components/tender_search";
import registerActivityLinkablePicker from "./components/activity_linkable_picker";
import registerActivityDayCalendar from "./components/activity_day_calendar";
import registerTutorialSearch from "./components/tutorial_search";
import registerAdeptConnectionWizard from "./components/adept_connection_wizard";
import registerAdept4ConnectionWizard from "./components/adept4_connection_wizard";
import registerNpsBanner from "./components/nps_banner";
import registerCookieConsent from "./components/cookie_consent";
import registerQuickEditDrawer from "./components/quick_edit_drawer";
import registerFilePreview from "./components/file_preview";
import registerMergeFieldsSidebar from "./components/merge_fields_sidebar";
import registerReschedulePopover from "./components/reschedule_popover";
import registerAutosize from "./components/autosize";
import registerLogActivityBody from "./components/log_activity_body";
import registerCopyButton from "./components/copy_button";
import registerClipboardCopy from "./components/clipboard_copy";
import registerProposalComposer from "./components/proposal_composer";
import registerDocumentRegionEditor from "./components/document_region_editor";
import registerCustomerMergeModal from "./components/customer_merge_modal";
import registerProductsCard from "./components/products_card";
import registerProposalConfigurator from "./components/proposal_configurator";
import registerProposalSignature from "./components/proposal_signature";

registerEditor(Alpine);
registerProductsCard(Alpine);
registerProposalConfigurator(Alpine);
registerProposalSignature(Alpine);
registerSectionEditor(Alpine);
registerKanban(Alpine);
registerCelebration(Alpine);
registerGlobalSearch(Alpine);
registerChat(Alpine);
registerDatepicker(Alpine);
registerModal(Alpine);
registerNotifications(Alpine);
registerDropzone(Alpine);
registerCalendar(Alpine);
registerAvailabilityPicker(Alpine);
registerPageEditor(Alpine);
registerAgentJob(Alpine);
registerAgentPanel(Alpine);
registerStageSortable(Alpine);
registerSidebar(Alpine);
registerMentionLink(Alpine);
registerMentionTextarea(Alpine);
registerAnchorHighlight(Alpine);
registerTimelineMentionedMe(Alpine);
registerMarkdownEditor(Alpine);
registerAiTemplateGenerator(Alpine);
registerEmailCompose(Alpine);
registerComposeHelpers(Alpine);
registerAddressAutocomplete(Alpine);
registerBookingCalendar(Alpine);
registerAvailabilityRules(Alpine);
registerTableCustomizer(Alpine);
registerBulkSelect(Alpine);
registerLineItemModal(Alpine);
registerProductsModal(Alpine);
registerSignaturePad(Alpine);
registerBundleViewer(Alpine);
registerOtpInput(Alpine);
registerPhoneInput(Alpine);
registerCounterSignModal(Alpine);
registerContactPicker(Alpine);
registerCustomerPicker(Alpine);
registerMoveContactModal(Alpine);
registerOpportunityEditModal(Alpine);
registerTenderSearch(Alpine);
registerActivityLinkablePicker(Alpine);
registerActivityDayCalendar(Alpine);
registerTutorialSearch(Alpine);
registerAdeptConnectionWizard(Alpine);
registerAdept4ConnectionWizard(Alpine);
registerNpsBanner(Alpine);
registerCookieConsent(Alpine);
registerQuickEditDrawer();
registerFilePreview(Alpine);
registerMergeFieldsSidebar(Alpine);
registerReschedulePopover(Alpine);
registerAutosize(Alpine);
registerLogActivityBody(Alpine);
registerCopyButton(Alpine);
registerClipboardCopy(Alpine);
registerProposalComposer(Alpine);
registerDocumentRegionEditor(Alpine);
registerCustomerMergeModal(Alpine);

window.Alpine = Alpine;
window.Sortable = Sortable;
Alpine.start();

// Apply theme on page load (before render to avoid flash)
if (
  localStorage.getItem("color-theme") === "dark" ||
  (!("color-theme" in localStorage) && window.matchMedia("(prefers-color-scheme: dark)").matches)
) {
  document.documentElement.classList.add("dark");
} else {
  document.documentElement.classList.remove("dark");
}

// Dark mode toggle — use event delegation to avoid duplicate listeners with Turbo
document.addEventListener("click", (e) => {
  const btn = e.target.closest("#theme-toggle");
  if (!btn) return;

  const darkIcon = document.getElementById("theme-toggle-dark-icon");
  const lightIcon = document.getElementById("theme-toggle-light-icon");
  if (!darkIcon || !lightIcon) return;

  darkIcon.classList.toggle("hidden");
  lightIcon.classList.toggle("hidden");

  if (document.documentElement.classList.contains("dark")) {
    document.documentElement.classList.remove("dark");
    localStorage.setItem("color-theme", "light");
  } else {
    document.documentElement.classList.add("dark");
    localStorage.setItem("color-theme", "dark");
  }
});

// Set initial icon visibility based on current theme
function syncThemeIcons() {
  const darkIcon = document.getElementById("theme-toggle-dark-icon");
  const lightIcon = document.getElementById("theme-toggle-light-icon");
  if (!darkIcon || !lightIcon) return;

  const isDark =
    localStorage.getItem("color-theme") === "dark" ||
    (!("color-theme" in localStorage) && window.matchMedia("(prefers-color-scheme: dark)").matches);

  darkIcon.classList.toggle("hidden", isDark);
  lightIcon.classList.toggle("hidden", !isDark);
}

document.addEventListener("turbo:load", syncThemeIcons);
document.addEventListener("DOMContentLoaded", syncThemeIcons);

// Report the browser's IANA time zone so the server can fall back to it
// when the signed-in user's stored time_zone is still the "UTC" default.
function syncBrowserTimeZone() {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (!tz) return;
    const encoded = encodeURIComponent(tz);
    const secure = window.location.protocol === "https:" ? "; Secure" : "";
    document.cookie = `browser_tz=${encoded}; path=/; max-age=31536000; SameSite=Lax${secure}`;
  } catch (_e) {
    // Ignore — older browsers without Intl support fall through to user.time_zone.
  }
}

syncBrowserTimeZone();
document.addEventListener("turbo:load", syncBrowserTimeZone);
